import { FormattedMessage, injectIntl, intlShape } from 'react-intl';
import ImmutablePropTypes from 'react-immutable-proptypes';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styles from './css/Address.scss';

@injectIntl
export default class Address extends Component {
    static propTypes = {
        hideBillingAdress: PropTypes.bool,
        intl: intlShape,
        location: ImmutablePropTypes.map.isRequired,
    }

    renderLocation() {
        const { location } = this.props;
        return location && (
            <address className={styles.section}>
                <ul className={styles.details}>
                    <li>{location.getIn(['address', 'organization'])} - {location.get('info')}</li>
                    <li>
                        {location.get('contact')}
                    </li>
                    <li>
                        {location.getIn(['address', 'phone'])} - {location.getIn(['address', 'email'])}
                    </li>
                </ul>
            </address>
        );
    }

    renderLocationAddress() {
        const { location } = this.props;
        const address = location.get('address');

        return address && (
            <address className={styles.section}>
                <ul className={styles.details}>

                    {address.get('building') && (
                        <li>
                            <FormattedMessage id='frontend.form_selector_shipping.label.building' />
                            {address.get('building')}
                        </li>
                    )}
                    <li>{address.get('street')}</li>
                    <li>{address.get('zip')} {address.get('city')}</li>

                </ul>
            </address>
        );
    }

    render() {
        const { location } = this.props;
        if (!location) return null;

        return (
            <div className={styles.wrapper}>
                <div className={styles.headingContainer}>
                    <h4 className={styles.heading}>
                        {' #'}{location.get('number')}
                        {location.get('old_number') && (
                            <small>( {location.get('old_number')})</small>
                        )}
                    </h4>
                </div>
                <div className={styles.sections}>
                    {this.renderLocation()}
                    {this.renderLocationAddress()}
                </div>
            </div>
        );
    }
}
